import { createContext, useContext } from 'react';

import type { OutboxKind, OutboxOp } from '@/offline/outbox';

export interface NewOp {
  kind: OutboxKind;
  url: string;
  body: Record<string, unknown>;
  label: string;
}

export interface Outbox {
  /** Связь с сервером есть (по последним запросам и браузеру). */
  online: boolean;
  ops: OutboxOp[];
  queued: OutboxOp[];
  failed: OutboxOp[];
  sending: boolean;
  enqueue: (op: NewOp) => OutboxOp;
  /** Запрос не дошёл до сервера — отметить «нет связи». */
  markOffline: () => void;
  flush: () => Promise<void>;
  /** Вернуть операцию из «Требует внимания» в очередь (можно с исправленными данными). */
  retry: (key: string, body?: Record<string, unknown>) => void;
  discard: (key: string) => void;
}

const noop = () => undefined;

export const OutboxContext = createContext<Outbox>({
  online: true,
  ops: [],
  queued: [],
  failed: [],
  sending: false,
  enqueue: (op) => ({ ...op, key: '', createdAt: '', state: 'queued' }),
  markOffline: noop,
  flush: () => Promise.resolve(),
  retry: noop,
  discard: noop,
});

export function useOutbox(): Outbox {
  return useContext(OutboxContext);
}
